import { render } from "./CleanerSettingsForm.vue?vue&type=template&id=ef0e0c68"
import script from "./CleanerSettingsForm.vue?vue&type=script&lang=js"
export * from "./CleanerSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__